module.exports = __webpack_public_path__ + "static/media/service-1.34e509b3.png";